import { render, staticRenderFns } from "./schedule_participant_curriculum.vue?vue&type=template&id=1aa1b132&"
import script from "./schedule_participant_curriculum.vue?vue&type=script&lang=js&"
export * from "./schedule_participant_curriculum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports